import axios from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

// Create scheduler
const createScheduler = async (data) => {
  const user = getUserDetails();
  const response = await axios.post(
    `${API_BACKEND_URL}/scheduler/createScheduler`,
    {
      companyId: user.companyid,
      frequency: data.frequency,
      scheduleBy: user.email,
      scheduleDate: data.scheduleDate,
      scheduleTime: data.scheduleTime,
      subfrequency: data.subfrequency || "none",
      suiteId: data.suiteId,
      timeInterval: data.timeInterval || 0
    }
  );
  return response.data;
};

export const useCreateScheduler = (options = {}) => {
  return useMutation({
    mutationFn: createScheduler,
    ...options,
  });
};

// Get suite schedulers
const getSuiteSchedulers = async (suiteId) => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BACKEND_URL}/scheduler/suite/${suiteId}`
  );
  return response.data;
};

export const useGetSuiteSchedulers = (suiteId, options = {}) => {
  return useQuery({
    queryKey: ["suiteSchedulers", suiteId],
    queryFn: () => getSuiteSchedulers(suiteId),
    enabled: !!suiteId,
    ...options,
  });
};


//delete a schedular

const deleteSchedular = async (idScheduler) => {
  const response = await axios.delete(
    `${API_BACKEND_URL}/scheduler/${idScheduler}`
  );
  return response.data;
};

export const useDeleteApiSchedular = (options = {}) => {
  return useMutation({
    mutationFn: deleteSchedular,
    ...options,
  });
};
